import { IClassname } from '@/lib/shared/model/classname';

export const FirstAid = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.3005 26.5501C27.8348 28.2009 26.6039 29.8929 24.8689 29.8929H7.13192C5.39683 29.8929 4.16602 28.2009 4.70027 26.5501L6.40678 21.2769C6.73789 20.2538 6.73789 19.1523 6.40678 18.1292L4.70027 12.856C4.16603 11.2052 5.39685 9.51318 7.13192 9.51318H24.8689C26.6039 9.51318 27.8348 11.2052 27.3005 12.856L25.594 18.1292C25.2629 19.1523 25.2629 20.2538 25.594 21.2769L27.3005 26.5501Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0503 23.6639C14.0503 24.3697 14.6224 24.9418 15.3282 24.9418H16.6764C17.3822 24.9418 17.9543 24.3697 17.9543 23.6639V21.6553H19.9645C20.6702 21.6553 21.2424 21.0832 21.2424 20.3774V19.0292C21.2424 18.3234 20.6702 17.7513 19.9645 17.7513H17.9543V15.7428C17.9543 15.037 17.3822 14.4648 16.6764 14.4648H15.3282C14.6224 14.4648 14.0503 15.037 14.0503 15.7428V17.7513H12.0433C11.3375 17.7513 10.7654 18.3234 10.7654 19.0292V20.3774C10.7654 21.0832 11.3375 21.6553 12.0433 21.6553H14.0503V23.6639Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5707 4.16737L17.9319 9.51355H24.6734L25.4513 5.86201C25.7249 4.57757 24.999 3.29042 23.7583 2.86002C22.5181 2.42982 21.1516 2.99025 20.5707 4.16737Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
